import { render, staticRenderFns } from "./EditBorangLaporan.vue?vue&type=template&id=50525556&scoped=true&"
import script from "./EditBorangLaporan.vue?vue&type=script&lang=js&"
export * from "./EditBorangLaporan.vue?vue&type=script&lang=js&"
import style0 from "./EditBorangLaporan.vue?vue&type=style&index=0&id=50525556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50525556",
  null
  
)

export default component.exports